import { createContext, ReactNode, useContext, useMemo, useState } from 'react';
import { Locale, resolveLocale } from './resolveLocale';

type LocaleContextValue = {
  locale: Locale;
  setLocale: (locale: Locale) => void;
};

const LocaleContext = createContext<LocaleContextValue | null>(null);

export function LocaleProvider({ children }: { children: ReactNode }) {
  const [locale, setLocaleState] = useState<Locale>(() =>
    resolveLocale({
      pathname: window.location.pathname,
      storedLocale: window.localStorage.getItem('vibeArcade.locale'),
      browserLanguages: navigator.languages
    })
  );

  const value = useMemo<LocaleContextValue>(() => ({
    locale,
    setLocale(nextLocale) {
      window.localStorage.setItem('vibeArcade.locale', nextLocale);
      setLocaleState(nextLocale);
    }
  }), [locale]);

  return <LocaleContext.Provider value={value}>{children}</LocaleContext.Provider>;
}

export function useLocale() {
  const value = useContext(LocaleContext);
  if (!value) throw new Error('useLocale must be used inside LocaleProvider');
  return value;
}
